"use strict";

exports.__esModule = true;
exports.assertPreconditions = void 0;

var validateCache = function validateCache(cache) {
  if (!cache || !cache.readQuery || !cache.writeQuery) {
    throw new TypeError('WatchedMutationLink requires a cache with a readQuery and writeQuery interface');
  }
};

var validateMutationQueryResolverMap = function validateMutationQueryResolverMap(map) {
  if (!map || typeof map !== 'object') {
    throw new TypeError('WatchedMutationLink requires a valid mutation -> query -> updateFn map');
  }

  var mutationKeys = Object.keys(map);
  var invalidMutationKeys = mutationKeys.filter(function (name) {
    return typeof name !== 'string';
  });

  if (invalidMutationKeys.length) {
    throw new TypeError('WatchedMutationLink requires valid MutationNames as keys in the mutation map provided');
  }

  var queryKeys = mutationKeys.reduce(function (keyList, key) {
    var queryMap = map[key];

    if (typeof queryMap !== 'object') {
      throw new TypeError('WatchedMutationLink requires a valid mutation -> query -> updateFn map');
    }

    return keyList.concat(Object.keys(queryMap));
  }, []);
  var invalidQueryKeys = queryKeys.filter(function (name) {
    return typeof name !== 'string';
  });

  if (invalidQueryKeys.length) {
    throw new TypeError('WatchedMutationLink requires valid QueryNames as keys in the query map provided');
  }

  var updateFns = mutationKeys.reduce(function (updateFnList, key) {
    return updateFnList.concat(Object.values(map[key]));
  }, []);
  var invalidUpdateFns = updateFns.filter(function (fn) {
    return typeof fn !== 'function';
  });

  if (invalidUpdateFns.length) {
    throw new TypeError('WatchedMutationLink requires valid functions as values in the resolver -> query map provided');
  }
};

var assertPreconditions = function assertPreconditions(cache, map) {
  validateCache(cache);
  validateMutationQueryResolverMap(map);
};

exports.assertPreconditions = assertPreconditions;